$(document).ready(function () {

     // PRODUCT detail Slider

       var $mainSlider = $('.slider-product');
       var initialSlide = parseInt($mainSlider.attr('data-initial-slide'), 10);
       if (isNaN(initialSlide)) initialSlide = 0;
       $mainSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: false,
          infinite: false,
          speed: 1000,
          asNavFor: '.slider-thumb',
          initialSlide: initialSlide,
        });
        $('.slider-thumb').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.slider-product',
          dots: false,
          arrows: true,
          centerMode: false,
          infinite: false,
          focusOnSelect: true,
          initialSlide: initialSlide,
          responsive: [
              {
                breakpoint: 1440,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                   arrows: false,
                },
              },
              {
                breakpoint: 481,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows: false,
                },
              },
              {
                breakpoint: 360,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  arrows: false,
                },
              }
            ],


        });



      // Package pizza

	$(".related-slider").slick({
			arrows: true,
			dots: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1440,
					settings: {
					slidesToShow: 4,

					}
				},
				{
					breakpoint: 1200,
					settings: {
					slidesToShow: 3,
					}
				},
				{
					breakpoint: 992,
					settings: {
					slidesToShow: 2,
					}
				},
				{
					breakpoint: 450,
					settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '20px',
					}
				},
			],
	  });


    });

    /*Increment input*/
    function increaseValue(ele) {
        console.log(ele.parent().find('input[type="number"]').val());
        var value = ele.parent().find('input[type="number"]').val();
        // var value = parseInt(inputele.value, 10);
        value = isNaN(value) ? 0 : value;
        value++;
        ele.parent().find('input[type="number"]').val(value);
        if (value == 0) {
            ele.parents('.roomlistbox').removeClass('selectedinput');
            if ($('.quantity').length > 0) {
                ele.parents('.quantity').parent().prev().parent().removeClass('selectedinput');
            }
        } else {
            ele.parents('.roomlistbox').addClass('selectedinput');
            if ($('.quantity').length > 0) {
                ele.parents('.quantity').parent().prev().parent().addClass('selectedinput');
            }
        }
    }

    function decreaseValue(ele) {
        var value = ele.parent().find('input[type="number"]').val();
        //    var value = parseInt(inputele.value, 10);
        value = isNaN(value) ? 0 : value;
        value < 1 ? value = 1 : '';
        value--;
        ele.parent().find('input[type="number"]').val(value);
        if (value == 0) {
            ele.parents('.roomlistbox').removeClass('selectedinput');
            if ($('.quantity').length > 0) {
                ele.parents('.quantity').parent().prev().parent().removeClass('selectedinput');
            }
        } else {
            ele.parents('.roomlistbox').addClass('selectedinput');
            if ($('.quantity').length > 0) {
                ele.parents('.quantity').parent().prev().parent().addClass('selectedinput');
            }
        }
    }

    